import { FC } from "react"
import dropdownIcon from './../../../../assets/Navbar/chevronBot.svg'
import ImageComponent from "./ImageComponent"

type IProps = {
    label: string,
    className?: string,
    onMouseEnter?: () => void;
}

const MenuDropdownWithoutOptions: FC<IProps> = ({ label, className = '', onMouseEnter }) => {
    return (
        <button onMouseEnter={() => {
            if (onMouseEnter) {
                onMouseEnter()
            }
        }}
            className={`text-[#1a1a1a] font-semibold flex gap-[12px] items-center ${className}`}
        >
            <span>{label}</span>
            <ImageComponent
                source={dropdownIcon}
                alt="drowndown-icon"
                width="9px"
                height="5px"
                className="mt-[4px]"
            />
        </button>
    )
}

export default MenuDropdownWithoutOptions